import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { bodyXs } from '@helpers/typography';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled.div `
  &[data-no-padding='false']:not(:only-child) {
    ${siteWide};
    &:not(${SectionWrapperStyles.Container} &) {
      padding-top: var(--sectionSpacing);
      padding-bottom: var(--sectionSpacing);
    }
  }

  &:only-child {
    // Has been rendered standalone, apply only the padding it needs
    ${siteWide}
    padding-top: calc(var(--sectionSpacing) / 2);
  }

  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
  color: var(--widgetFg, ${brand.ngbBlue.default});

  &[data-theme='white'] {
    color: var(--widgetFg, ${brand.global.white});
  }

  > a,
  > span {
    text-decoration: none;
    color: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    ${bodyXs};
  }

  > a {
    text-decoration: underline;
    ${fonts.montserrat.bold};
  }
`;
const Spacer = styled.div `
  width: 1px;
  background-color: ${brand.skyBlue.default};
  margin: 4px 0px;
  flex-shrink: 0;
`;
export const BreadcrumbsStyles = {
    Container,
    Spacer,
};
